import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useCartContext } from 'screens/AccessExpressV3/CartProvider';
import ProductPriceInfo from '../ReviewOrderModal/ProductPriceInfo';
import { ChevronDown } from 'react-ionicons';

interface ProductInfoProps {
  name: string;
  price?: number;
  secondPrice?: number;
  quantity?: number;
  className?: string;
  id?: string;
  openedDetails?: boolean;
}

const ProductInfo = observer(
  ({
    name,
    price,
    quantity,
    secondPrice,
    className,
    id,
    openedDetails,
  }: ProductInfoProps) => {
    const { priceChange } = useCartContext();

    const shouldAnimatePrice = id && priceChange[id];

    return (
      <div
        className={clsx(
          'item pointer-events-none flex flex-grow flex-col justify-center gap-2',
          className,
        )}
      >
        <div className="text-slate-50 text-xs font-bold text-content-base-default">
          {name}
        </div>
        <div className="flex gap-1 text-xs font-semibold">
          <div
            className={clsx(
              'flex flex-row gap-2 text-content-base-default transition-all duration-500',
              shouldAnimatePrice && 'scale-95 animate-pulse',
            )}
          >
            {price || secondPrice ? (
              <>
                {!!price && <ProductPriceInfo price={price} repeat />}
                {!!secondPrice && (
                  <span className="flex flex-row gap-1">
                    {!!price && '+'}
                    <ProductPriceInfo price={secondPrice} />
                  </span>
                )}
              </>
            ) : (
              <ProductPriceInfo price={0} />
            )}
            {openedDetails !== undefined && (
              <div
                className={clsx(
                  'transition-all duration-300 ease-in-out group-hover/cart-item:text-content-base-default',
                  { '-scale-y-100': openedDetails },
                )}
              >
                <span
                  className={clsx(
                    'flex transition-transform duration-300 ease-in-out',
                    { 'group-hover/cart-item:translate-y-0.5': !openedDetails },
                  )}
                >
                  <ChevronDown
                    width="16px"
                    height="16px"
                    color="currentColor"
                  />
                </span>
              </div>
            )}
          </div>
          {quantity && <span className="opacity-50">x {quantity}</span>}
        </div>
      </div>
    );
  },
);

export default ProductInfo;
